import { __assign } from "tslib";
import lowerBound from './lower-bound.js';
var PriorityQueue = /** @class */ (function () {
    function PriorityQueue() {
        this._queue = [];
    }
    PriorityQueue.prototype.enqueue = function (run, options) {
        options = __assign({ priority: 0 }, options);
        var element = {
            priority: options.priority,
            run: run
        };
        if (this.size && this._queue[this.size - 1].priority >= options.priority) {
            this._queue.push(element);
            return;
        }
        var index = lowerBound(this._queue, element, function (a, b) { return b.priority - a.priority; });
        this._queue.splice(index, 0, element);
    };
    PriorityQueue.prototype.dequeue = function () {
        var item = this._queue.shift();
        return item === null || item === void 0 ? void 0 : item.run;
    };
    PriorityQueue.prototype.filter = function (options) {
        return this._queue
            .filter(function (element) { return element.priority === options.priority; })
            .map(function (element) { return element.run; });
    };
    Object.defineProperty(PriorityQueue.prototype, "size", {
        get: function () {
            return this._queue.length;
        },
        enumerable: false,
        configurable: true
    });
    return PriorityQueue;
}());
export default PriorityQueue;
//# sourceMappingURL=priority-queue.js.map